<template>
  <div>
    <z-centralized-toolbar>
      <v-btn
        depressed
        rounded
        color="primary"
        @click="novoLancamento"
      >
        <v-icon left>mdi-plus</v-icon>
        Lançar Conta a Pagar
      </v-btn>
      
      <v-btn
        :text="!exibir_filtro"
        :depressed="exibir_filtro"
        rounded
        :color="exibir_filtro ? 'primary' : 'default'"
        @click="exibir_filtro = !exibir_filtro"
      >
        <v-icon left>{{ $icon.FILTRAR }}</v-icon>
        Filtrar
      </v-btn>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            :loading="$store.state.loading"
            @click="refresh"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        Atualizar
      </v-tooltip>

      <!-- <v-spacer></v-spacer> -->

      <z-date-navigation
        v-if="exibir_date_navigation"
        v-model="filtro.data"
        tipo="month"
        @input="onChangeDateNavigation"
      ></z-date-navigation>

    </z-centralized-toolbar>

    <z-container>
      <v-slide-y-transition>
        <ContasPagarFiltro v-show="exibir_filtro" @filtrar="filtrar" @cancelar="cancelarFiltro"></ContasPagarFiltro>
      </v-slide-y-transition>



      <v-container fluid class="pa-0 mb-3" v-if="contaspagar.length > 0">
        <v-row dense justify="end">
          <v-col cols="12" sm="3" md="2">
            <z-big-number
              titulo="Valor Total"
              :valor="totalValor"
            ></z-big-number>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <z-big-number
              titulo="Total a Pago"
              :valor="totalValorPago"
            ></z-big-number>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <z-big-number
              titulo="Total a Pagar"
              :valor="totalValorRestante"
            ></z-big-number>
          </v-col>
        </v-row>
      </v-container>

      <h3 class="text-body-1 mb-3 mt-n10">Contas a Pagar</h3>

      <v-card>

        <v-data-table
          hide-default-footer
          item-key="id"
          disable-pagination
          disable-sort
          :headers="headers"
          :items="contaspagar"
          :loading="false"
        >
          <template #item.pago="{ item }">
            <v-icon v-if="item.valor_restante == 0" small color="green">mdi-circle</v-icon>
            <v-icon v-else small color="red">mdi-circle-outline</v-icon>
          </template>

          <template #item.documento="{ item }">
            <router-link @click.native.stop target="_blank" :to="{ name: 'ExtratoFornecedor', params: { id: item.fornecedor.id } }">{{ item.documento }}</router-link>
          </template>

          <template #item.vencimento="{ item }">
            {{ item.vencimento | dataBR }}
          </template>

          <template #item.data_pagamento="{ item }">
            {{ item.data_pagamento | dataBR }}
          </template>

          <template #item.valor="{ item }">
            <span>{{ item.valor | valorBR }}</span>
          </template>

          <template #item.valor_pago="{ item }">
            <span>{{ item.valor_pago | valorBR }}</span>
          </template>

          <template #item.valor_restante="{ item }">
            <span>{{ item.valor_restante | valorBR }}</span>
          </template>

          <template #item.fornecedor="{ item }">
            <div>
              <span v-if="item.fornecedor">{{ item.fornecedor.id }} - {{ item.fornecedor.razao }}</span>
              <span v-else>Não Informado</span>
            </div>
            <div class="text--secondary">
              <template v-if="item.categoria">
                <!-- <v-icon small :color="item.categoria.cor">mdi-circle</v-icon> -->
                {{ item.categoria.descricao }}
              </template>
              <template v-else>
                <v-icon small color="green">mdi-circle</v-icon>
                Entrada Estoque
              </template>
            </div>
          </template>

          <!-- <template #item.categoria="{ item }" class="text-no-wrap">
          </template> -->

          <!-- <template #item.opcoes="{ item }">
            <div class="text-no-wrap">
              <v-btn icon v-if="!item.pago">
                <v-icon @click="pagar(item)">mdi-checkbox-marked-circle</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon @click="editar(item)">mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon @click="excluir(item)">mdi-delete</v-icon>
              </v-btn>
            </div>
          </template> -->

          <template #body.append>
            <tr>
              <td colspan="5"></td>
              <td class="text-right font-weight-bold">{{ totalValor | valorBR }}</td>
              <td class="text-right font-weight-bold">{{ totalValorPago | valorBR }}</td>
              <td class="text-right font-weight-bold">{{ totalValorRestante | valorBR }}</td>
            </tr>
          </template>

        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo
      ref="dialogoLancamento"
      :titulo="titulo"
      largura="700px"
      eager
      :dividers="true"
      persistent
    >
      <template v-slot:texto>
        <v-form ref="form" v-model="form_valido" lazy-validation>
          <v-row dense>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="contapagar.documento"
                ref="descricao"
                label="Descrição/Documento"
                autofocus
                filled
                dense
                :disabled="contapagar.pago == 1 || isPagando"
                :rules="regras.descricao"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" v-if="!isPagando">
              <z-campo-valor
                v-model="contapagar.valor"
                label="Valor"
                ref="valor"
                dense
                :disabled="contapagar.pago == 1"
                :rules="regras.valor"
              ></z-campo-valor>
            </v-col>

            <v-col cols="12" sm="4" v-if="contapagar.pago == 1 || isPagando">
              <z-campo-valor
                v-model="contapagar.valor_pago"
                :label="isPagando ? 'Valor' : 'Valor Pago'"
                ref="valor"
                dense
                :disabled="contapagar.pago == 1"
                :rules="regras.valor"
              ></z-campo-valor>
            </v-col>

            <v-col cols="12" sm="4">
              <z-date-picker-menu
                v-model="contapagar.vencimento"
                label="Data Vencimento"
                dense
                :disabled="contapagar.pago == 1 || isPagando"
              ></z-date-picker-menu>
            </v-col>

            <v-col cols="12" sm="4" v-if="contapagar.pago">
              <z-date-picker-menu
                v-model="contapagar.data_pagamento"
                label="Data Pagamento"
                dense
                :disabled="contapagar.pago == 1"
              ></z-date-picker-menu>
            </v-col>

            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="contapagar.categoria_id"
                dense
                label="Categoria"
                filled
                :items="$store.state.listas.contas_pagar_categorias"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
              <v-select
                v-model="contapagar.forma_pagamento"
                label="Forma de Pagamento"
                filled
                dense
                :items="$globals.FORMAS_DE_PAGAMENTO_CAIXA"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="4" v-if="!isCriando">
              <v-select
                v-model="contapagar.pago"
                label="Pago"
                filled
                dense
                :items="[
                  { text: 'Sim', value: 1 },
                  { text: 'Não', value: 0 }
                ]"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="12">
              <v-autocomplete
                v-model="contapagar.fornecedor_id"
                dense
                label="Fornecedor"
                filled
                clearable
                rules_="regras.obrigatorio"
                :items="$store.getters['listas/fornecedores']"
              ></v-autocomplete>
            </v-col>

            <v-row dense v-if="isCriando">
              <v-col cols="12" sm="4">
                <v-select
                  v-model="contapagar.dividir_parcelar"
                  label="Repetir/Dividir"
                  filled
                  dense
                  :items="['Repetir', 'Dividir']"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <z-text-field
                  v-model="contapagar.parcelas"
                  label="Parcelas"
                  type="number"
                  min="1"
                  step="1"
                  dense
                  :hint="parcelado"
                  persistent-hint
                ></z-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <z-select
                  v-model="contapagar.recorrencia"
                  label="Recorrência"
                  dense
                  :items="['Semanal', 'Quinzenal', 'Mensal', 'Bimestral', 'Trimestral', 'Semestral', 'Anual']"
                ></z-select>
              </v-col>


            </v-row>

          </v-row>

        </v-form>
      </template>


      <template #actions_left>
        <v-switch 
          v-if="!isCriando"
          v-model="contapagar.pago" 
          class="my-0 shrink" 
          color="primary" 
          label="Pago"
          :true-value="1"
          :false-value="0"
          hide-details 
        ></v-switch>
      </template>

      <template #actions_right>
        <v-btn text @click="$refs.dialogoLancamento.fechar()" :disabled="salvando">Cancelar</v-btn>
        <v-btn
          color="primary"
          depressed
          :loading="salvando"
          :disabled="salvando || !form_valido"
          @click="confirmarLancamento"
          >{{ textoSalvar }}</v-btn>

      </template>

    </z-dialogo>

    <z-dialogo-sim-nao 
      ref="dialogoExcluirConta" 
      titulo="Excluir Conta a Pagar?" 
      botaoSim="Excluir" 
      botaoNao="Cancelar" 
      :loading="excluindo"
    >
      A conta a pagar será excluída. Deseja continuar?

      <template v-if="contapagar.codigoparcelas">
        <v-alert
          class="mt-5"
          dense
          text
          type="error"
        >
          Essa conta a pagar possui repetições
        </v-alert>
        <v-checkbox
          v-model="excluir_repeticoes"
          label="Deseja excluir as repetições?"
        ></v-checkbox>
      </template>
    </z-dialogo-sim-nao>

    <contas-pagar-form ref="contasPagarForm" :titulo="titulo" :operacao="operacao" @onSave="refresh"></contas-pagar-form>
    <contas-pagar-pagar-form ref="contasPagarPagarForm"></contas-pagar-pagar-form>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";

import { abrirJanela } from '@/app/helpers/utils';
import config from "@/app/config";
import MesesAnos from './MesesAnos';
import CaixaDiario from './CaixaDiario';
import ContasPagarForm from './ContasPagarForm';
import ContasPagarPagarForm from './ContasPagarPagarForm';
import ContasPagarFiltro from "./ContasPagarFiltro.vue";
import queryBuilder from '@/app/helpers/QueryBuilder';
import { useContasPagarStore } from '@/app/store/pinia/contaspagar.js';


export default {
  name: 'ContasPagarLista',

  components: {
    MesesAnos,
    CaixaDiario,
    ContasPagarForm,
    ContasPagarPagarForm,
    ContasPagarFiltro
  },

  data() {
    return {
      // globals,
      headers: [
        { text: "Pago", value: "pago", width: "10px" },
        { text: "Descrição/Documento", value: "documento" },
        { text: "Vencimento", value: "vencimento", width: "120px" },
        { text: "Último Pag.", value: "data_pagamento", width: "120px" },
        { text: "Fornecedor/Categoria", value: "fornecedor"},
        // { text: "Categoria", value: "categoria"},
        { text: "Valor", value: "valor", align: "right" },
        { text: "Valor Pago", value: "valor_pago", align: "right", width: "130px" },
        { text: "Valor Restante", value: "valor_restante", align: "right", width: "120px" },
        // { text: "Opções", value: "opcoes", align: "right", sortable: false },
      ],

      impressoes: [
        { texto: 'Caixa do Dia', acao: 'caixa_diario', visible: true },
        { texto: 'Caixa Mensal', acao: 'caixa_mensal', visible: true },
        { texto: 'Caixa Período', acao: 'caixa_periodo', visible: true },
        { texto: 'Relatório Gerencial', acao: 'relatorio_gerencial', visible: this.$auth.isAdmin()}
      ],
      search: "",
      pagination: {},
      excluindo: false,
      salvando: false,
      titulo: "Lançamento de Conta a Pagar",
      lancamento: {
        vencimento: "",
        descricao: "",
        tipo: "",
        forma_pagamento: "",
        valor: "",
        dividir_parcelar: "Repetir",
        parcelas: 1,
        recorrencia: "Mensal",
      },
      regras: {
        descricao: [(v) => !!v || "O campo descrição é obrigatório"],
        valor: [(v) => v != "0,00" || "O campo valor não pode ser zero"],
        forma_pagamento: [
          (v) => !!v || "O campo forma de pagamento é obrigatório",
        ],
      },
      form_valido: false,
      form_valido_sangria: false,
      data: this.$moment().format("YYYY-MM-DD"),
      exibir_saldo: false,
      contaPagarStore: null,
      operacao: "criando",
      excluir_repeticoes: false,
      exibir_filtro: false,
      exibir_date_navigation: true,
    };
  },

  inject: ["$imprimir"],

  computed: {

    contaspagar() {
      return this.contaPagarStore.contaspagar;
    },

    contapagar() {
      return this.contaPagarStore.contapagar;
    },

    filtro() {
      return this.contaPagarStore.filtro;
    },

    caixaAtual() {
      return this.data == this.hoje();
    },

    parcelado() {

      if (this.contapagar.valor === 0 || this.contapagar.parcelas < 1) {
        return "";
      }

      if (this.contapagar.dividir_parcelar === "Repetir") {
        return `${this.contapagar.parcelas}x de R$ ${this.valorBR(this.contapagar.valor)}` ;
      } else {
        return `${this.contapagar.parcelas}x de R$ ${this.valorBR(this.contapagar.valor / this.contapagar.parcelas)}`;
      }
      
    },

    isCriando() {
      return this.operacao === "criando";
    },

    isEditando() {
      return this.operacao === "editando";
    },

    isPagando() {
      return this.operacao === "pagando";
    },

    textoSalvar() {
      if (this.isCriando) {
        return "Lançar";
      } else if (this.isPagando) {
        return "Pagar";
      }

      return "Salvar";
    },

    totalValor() {
      return this.contaspagar.reduce((total, item) => total + parseFloat(item.valor), 0);
    },
    totalValorPago() {
      return this.contaspagar.reduce((total, item) => total + parseFloat(item.valor_pago), 0);
    },
    totalValorRestante() {
      return this.contaspagar.reduce((total, item) => total + parseFloat(item.valor_restante), 0);
    },
  },

  created() {
    this.contaPagarStore = useContasPagarStore();
    this.$store.dispatch("listas/fornecedores");
    this.setTitulo("Contas a Pagar");
  },
  
  async mounted() {

    this.contaPagarStore.zerarFiltro();
    this.refresh();
    
    await this.$store.dispatch("listas/fetchListas", [
      queryBuilder()
        .from("ContaPagarCategoria")
        .selectraw("id as value, descricao as text, tipo")
        .orderBy("descricao")
        .where("tipo='Despesa'")
        .build()
    ]);

  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),


    async refresh() {
      
      try {
        await this.contaPagarStore.listar(this.filtro);
      } catch (error) {
        this.$eventbus.erro("Não foi possível obter a lista do caixa.", error);
        this.LOADING_OFF();
      }
    },

    novoLancamento() {
      this.$refs.form.resetValidation();
      this.operacao = "criando";
      this.contaPagarStore.zerar();
      // this.setFocus("descricao");
      this.titulo = "Lançamento de Conta a Pagar";

      this.$refs.contasPagarForm.abrir();
      // this.$refs.dialogoLancamento.abrir();
    },

    async editar(contapagar) {
      await this.contaPagarStore.abrir(contapagar);
      this.operacao = "editando";
      this.titulo = "Editar Conta a Pagar";
      this.$refs.contasPagarForm.abrir();

      // this.$refs.dialogoLancamento.abrir();
    },

    pagar(contapagar) {
      contapagar.valor_pago = contapagar.valor;
      contapagar.data_pagamento = this.$moment().format("YYYY-MM-DD");
      this.contaPagarStore.abrir(contapagar);
      this.$refs.contasPagarPagarForm.abrir();
    },

    async excluir(contapagar) {
      this.contaPagarStore.contapagar = contapagar;
      const resposta = await this.$refs.dialogoExcluirConta.abrir();

      if (resposta == false) {
        return;
      }

      
      try {
        this.excluindo = true;
        contapagar.excluir_repeticoes = this.excluir_repeticoes;
        await this.contaPagarStore.excluir(contapagar);

        this.$eventbus.notificar("Conta excluída com sucesso.");
      } catch (error) {
        this.$eventbus.erro("Não foi possível excluir a conta", error);
        throw error;
      } finally {
        contapagar.excluir_repeticoes = false;
        this.excluindo = false;
        this.$refs.dialogoExcluirConta.fechar()
      }

    },

    async confirmarLancamento() {
      if (this.$refs.form.validate()) {
        this.salvando = true;
        try {

          if (this.isPagando) {
            await this.contaPagarStore.pagar(this.contapagar);
          } else if (this.isCriando) {
            await this.contaPagarStore.salvar(this.contapagar);
          } else {
            await this.contaPagarStore.atualizar(this.contapagar);
          }
          
          this.$refs.dialogoLancamento.fechar();
        } catch (error) {
          throw error;
          this.$eventbus.erro("Não foi possível salvar o lançamento.", error);
          this.LOADING_OFF();
        } finally {
          this.salvando = false;
        }
      }
    },

    corChip(situacao) {
      switch (situacao) {
        case "Em Caixa":
          return "green";
          break;

        case "Compensado":
          return "blue";
          break;

        case "Devolvido":
          return "red";
          break;

        case "Repassado":
          return "orange";
          break;

        default:
          break;
      }
    },

    filtrar() {
      this.exibir_date_navigation = false;
      this.refresh();
    }, 
  
    cancelarFiltro() {
      this.exibir_filtro = false;
      this.exibir_date_navigation = true;
      this.contaPagarStore.zerarFiltro();
      // this.contaPagarStore.filtro = {};
      this.refresh();
    },

    async abrirExtratoFornecedor(contapagar) {
      // this.$store.commit("financeiro/limparlistas");
      // await this.$store.dispatch("clientes/abrir", contapagar.cliente_id);
      // this.$store.commit("financeiro/SET_TAB", 1);
      // this.$store.commit('clientes/SET_BUSCA', contapagar.razao);
      this.$router.push({ name: "ExtratoFornecedor" });
      // await this.$store.dispatch("financeiro/extratofornecedor");
    },

    async onChangeDateNavigation(novaData) {
      this.contaPagarStore.filtro.data = novaData;
      this.contaPagarStore.filtro.data_inicial = this.$moment(novaData).startOf('month').format("YYYY-MM-DD");
      this.contaPagarStore.filtro.data_final = this.$moment(novaData).endOf('month').format("YYYY-MM-DD");
      await this.refresh();
    },
  },


};
</script>

<style scoped></style>
